import * as React from "react";
import { useState, useEffect, useContext } from "react";
import NavbarDesktop from "../components/NavbarDesktop";
import { stateFromHTML } from "draft-js-import-html";
import { EditorState, convertToRaw } from "draft-js";
import RenderHtml from "react-native-render-html";
import { View, useWindowDimensions, ScrollView, Pressable } from "react-native";
import { GlobalSettingsContext } from "../context/GlobalSettingsProvider.js";
import { AppDataContext } from "../context/AppDataProvider.js";

export default function InformationScreen({ route, navigation }) {
  /**
   * By defalt it'll show the privacy policy
   */
  let paramsData = route?.params?.data;
  const [data, setData] = useState("");
  const [dataPrivacyPolicy, setDataPrivacyPolicy] = useState("");
  const [dataTermsConditions, setDataTermsConditions] = useState("");
  const [dataCookiePolicy, setDataCookiePolicy] = useState("");
  const [dataAboutUs, setDataAboutUs] = useState("");
  const { width, height } = useWindowDimensions();
  const { globalSettings } = useContext(GlobalSettingsContext);

  const { colors } = useContext(AppDataContext);

  useEffect(() => {
    async function loadResourcesAndDataAsync() {
      setDataCookiePolicy(
        globalSettings.find(
          (a) => a && a.description.toLowerCase() === "cookie policy"
        ).value
      );
      setDataPrivacyPolicy(
        globalSettings.find(
          (a) => a && a.description.toLowerCase() === "privacy policy"
        ).value
      );
      setDataAboutUs(
        globalSettings.find(
          (a) => a && a.description.toLowerCase() === "about us"
        ).value
      );
      setDataTermsConditions(
        globalSettings.find(
          (a) => a && a.description.toLowerCase() === "terms and conditions"
        ).value
      );
    }
    loadResourcesAndDataAsync();
  }, [globalSettings, paramsData, data]);

  function renderHtml(html) {
    html = html.trim();
    let result = html;
    const contentState = stateFromHTML(result.replace(/\\n/g, " "));
    const editorValue = EditorState.createWithContent(contentState);
    const blocks = convertToRaw(editorValue.getCurrentContent()).blocks;
    const mappedBlocks = blocks.map((block) => block.text.replace(/\\n/g, " "));
    let newText = "";
    for (let i = 0; i < mappedBlocks.length; i++) {
      const block = mappedBlocks[i];
      // handle last block
      if (i === mappedBlocks.length - 1) {
        newText += block;
      } else {
        // otherwise we join with \n, except if the block is already a \n
        if (block === "\n") {
          newText += block;
        } else {
          newText += block + "";
        }
      }
    }

    if (!globalSettings) {
      return (<></>);
    }

    return (
      <RenderHtml
        tagsStyles={{
          body: {
            whiteSpace: "normal",
            color: colors.text,
          },
          a: {
            color: colors.text,
          },
          p: {
            color: colors.text,
          },
        }}
        contentWidth={width}
        source={{
          html: result,
        }}
      />
    );
  }

  function displayData(data) {
    return (
      <React.Fragment>
        <View
          style={{
            flex: 1,
            flexDirection: "column",
          }}
        >
          <View pointerEvents="box-none" style={{ elevation: 2, zIndex: 2, }}>
            <NavbarDesktop
              navigate={navigation.navigate}
              setParams={navigation.setParams}
            />
          </View>
          <ScrollView
            style={
              width > 1000
                ? {
                  marginLeft: "auto",
                  marginRight: "auto",
                  width: 974,
                }
                : {}
            }
          >
            {renderHtml(data)}
          </ScrollView>
        </View>
      </React.Fragment>
    );
  }

  function content() {
    if (paramsData) {
      if (paramsData.toLowerCase() === "cookie policy") {
        return displayData(dataCookiePolicy);
      } else if (paramsData.toLowerCase() === "terms and conditions") {
        return displayData(dataTermsConditions);
      } else if (paramsData.toLowerCase() === "about us") {
        return displayData(dataAboutUs);
      } else if (paramsData.toLowerCase() === "privacy policy") {
        return displayData(dataPrivacyPolicy);
      }
    }
    return displayData(dataPrivacyPolicy);
  }

  return <React.Fragment>{content()}</React.Fragment>;
}
